module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/PANS-LABYRINTH.7d9511a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/PANS-LABYRINTH.jpg
// module id = Q8Fw
// module chunks = 0